import React from 'react';
import BreakdownRingChart from '../../../../../../../shared/designSystem/components/BreakdownRingChart';

// CampaignsDonut — thin adapter for the shared BreakdownRingChart.
// Surfaces only 'impressions' / 'clicks' dimensions (no CTR in v1 for the
// multi-DSP Campaigns card).
const CampaignsDonut = ({ data, height, selectedDimension = 'impressions' }) => (
  <BreakdownRingChart
    data={data}
    dimension={selectedDimension}
    height={height}
  />
);

export default CampaignsDonut;
